import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buId", "buOptions", "requestState", "fetchBusinessUnits", "ungatedForBusinessUnitPicker"];
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getBusinessUnits, getBusinessUnitsRequestState
// @ts-expect-error no types
} from 'FormsUI/selectors/BusinessUnits';
import { isUngatedForBusinessUnitPicker } from 'FormsUI/selectors/Gates';
import { getCurrentBusinessUnit } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
import { fetchBusinessUnits as fetchBusinessUnitsAction } from 'FormsUI/actions/BusinessUnits';
import { getSelectedBusinessUnitId } from 'FormsUI/selectors/FormCreation';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessUnitTagContainer = _ref => {
  let {
      buId,
      buOptions,
      requestState,
      fetchBusinessUnits,
      ungatedForBusinessUnitPicker
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const businessUnitId = ungatedForBusinessUnitPicker ? getCurrentBusinessUnit() : buId;
  useEffect(() => {
    fetchBusinessUnits();
  }, [fetchBusinessUnits]);
  if (requestState.shouldShowAsLoading()) {
    return null;
  }
  return /*#__PURE__*/_jsx(BusinessUnitTag, Object.assign({
    buId: businessUnitId,
    buOptions: buOptions,
    size: "sm"
  }, props));
};
const mapStateToProps = state => ({
  buId: getSelectedBusinessUnitId(state),
  buOptions: getBusinessUnits(state),
  requestState: getBusinessUnitsRequestState(state),
  ungatedForBusinessUnitPicker: isUngatedForBusinessUnitPicker(state)
});
const actionsToBind = {
  fetchBusinessUnits: fetchBusinessUnitsAction
};
export default connect(mapStateToProps, actionsToBind)(BusinessUnitTagContainer);